import { Component, Input, OnInit } from '@angular/core';
import { AppMessage } from 'src/app/models/app-message';

@Component({
  selector: 'app-main-details',
  templateUrl: './main-details.component.html',
  styleUrls: ['./main-details.component.css']
})
export class MainDetailsComponent implements OnInit {
  @Input() data:AppMessage;
  
  constructor() { }

  ngOnInit(): void {
  }

  customCompare(o1, o2) {
    return o1 == o2;
  }
}
